/**
 * Výběr typu podnikání.
 *
 * Kalkulačka se dřív ptala rovnou na e-commerce segment, takže výrobní ani
 * servisní firma neměla co vybrat. Typ se ptá jako první a rozhoduje, na co
 * se wizard zeptá dál. E-shop je jedna z voleb, ne opak ostatních: kdo ho
 * vybere, dostane celý e-commerce dotazník včetně segmentů.
 *
 * Zrcadlí core/typ_podnikani.py, klíče musí souhlasit.
 */
import React from 'react';

export const TYPY = [
  {
    klic: 'eshop',
    nazev: 'E-shop',
    popis: 'Prodej koncovým zákazníkům přes internetový obchod.',
    dotaz: 'Zeptáme se na segment, návratnost reklamy, návštěvnost a zásoby.',
  },
  {
    klic: 'obchod',
    nazev: 'Obchod a velkoobchod',
    popis: 'Nákup a další prodej zboží, kamenné prodejny nebo B2B odběratelé.',
    dotaz: 'Zeptáme se na odběratele a zásoby, na reklamu ne.',
  },
  {
    klic: 'vyroba',
    nazev: 'Výroba',
    popis: 'Vlastní výroba, ať už pro vlastní značku nebo v zakázce.',
    dotaz: 'Zeptáme se na zakázky, kapacitu a zásoby.',
  },
  {
    klic: 'sluzby',
    nazev: 'Služby',
    popis: 'Práce a know-how, nikoli zboží. Poradenství, řemeslo, agentura.',
    dotaz: 'Zeptáme se na zakázky a kapacitu, na zásoby ne.',
  },
  {
    klic: 'ostatni',
    nazev: 'Jiné zaměření',
    popis: 'Nic z toho nesedí, nebo firma dělá víc věcí zároveň.',
    dotaz: 'Ocenění postavíme na účetních výkazech a kvalitě podnikání.',
  },
];

/** Segment, který se pošle backendu, když typ není e-shop. */
export function segmentProTyp(klic) {
  return klic === 'eshop' ? null : klic;
}

export function TypPodnikaniVyber({ hodnota, onChange, chyba }) {
  return (
    <div className="form-group" style={{ marginBottom: '1.5rem' }}>
      <label style={{ display: 'block', marginBottom: '0.6rem' }}>
        Čím se vaše firma zabývá? *
      </label>
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(210px, 1fr))',
        gap: '0.75rem',
      }}>
        {TYPY.map(t => {
          const vybrano = hodnota === t.klic;
          return (
            <button
              key={t.klic}
              type="button"
              onClick={() => onChange(t.klic)}
              aria-pressed={vybrano}
              style={{
                textAlign: 'left',
                padding: '0.85rem 1rem',
                borderRadius: 'var(--radius, 4px)',
                cursor: 'pointer',
                background: vybrano ? 'var(--purple-mid)' : 'transparent',
                border: `1px solid ${vybrano ? 'var(--gold)' : 'var(--purple-mid)'}`,
                color: 'inherit',
                font: 'inherit',
              }}
            >
              <div style={{
                fontFamily: "'Source Serif 4', Georgia, serif",
                fontSize: '1.02rem',
                marginBottom: '0.2rem',
                color: vybrano ? 'var(--gold)' : 'var(--star-white)',
              }}>
                {t.nazev}
              </div>
              <div style={{ fontSize: '0.79rem', color: 'var(--text-dim)' }}>
                {t.popis}
              </div>
              <div style={{
                fontSize: '0.74rem',
                marginTop: '0.4rem',
                color: 'var(--purple-light)',
              }}>
                {t.dotaz}
              </div>
            </button>
          );
        })}
      </div>
      {chyba && <small className="chyba-pole">{chyba}</small>}
    </div>
  );
}

export default TypPodnikaniVyber;
